import axios from 'axios';
import { DiagramData } from '../types/diagramData';
import BaseService from './baseService';
import { AuthState } from '@okta/okta-auth-js';
import { IMappingFilterData } from '../types/mappingFilterData';

export default class DiagramService extends BaseService {
    constructor() {
        super();
    }

    public async get(filter: IMappingFilterData, authState: AuthState | null) {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/diagram/filter`, filter, this.getHeaders(authState));
            return response.data as DiagramData;
        } catch (error) {
            console.error("Error fetching API information:", error);
            throw error;
        }
    }
}